import React from "react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, styled } from "@mui/material";
import { Close as CloseIcon } from '@mui/icons-material';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { Row } from "antd";

const BootstrapDialog = styled(Dialog)(({ padding }) => ({
'& .MuiDialogContent-root':{
        'padding': padding || 'var(--sp-lg) calc(var(--sp-lg)*1)',
        'width': 'auto',
        'borderTop': '0',
        'backgroundColor': 'white',
    },
}))

const ImageZoom = ({ imageSrc, altSrc, fullScreen, children, padding }) => {
    
    const [showModal, setShowModal] = React.useState(false);

    const onClose = () => {
        setShowModal(false);
    }

    const imageUrl = (url) => {
        if (url?.type) {
            return URL.createObjectURL(url)
        }
        return url
    }

    return (
        <>
            <Box onClick={(evt) => {
                evt.stopPropagation();
                if (imageSrc) {
                    setShowModal(true);
                }
            }}>
                {children}
            </Box>

            <BootstrapDialog fullScreen={fullScreen} fullWidth open={showModal} onClose={onClose} padding={padding}>
                <DialogTitle>
                    {/* {title} */}
                </DialogTitle>
                    <CloseIcon  onClick={onClose}  sx={{
                        fontSize: 'calc(var(--fs-sm)*2)',position: 'absolute',
                            right: 'calc(var(--sp-xxs)*2)',
                            top: 'calc(var(--sp-xxs)*2)',
                            color: '#000', 
                            cursor: 'pointer'
                    }}/>
                <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',marginTop:'var(--sp-md2)', marginBottom:'var(--sp-md2)' }}>
                    <Zoom>
                        {imageSrc && (
                            <Row justify="center">
                                <TransformWrapper>
                                    <TransformComponent>
                                        <img
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                maxHeight: 'calc(var(--fs-hero)*11.32075)',
                                            }}
                                            // onLoad={this.onImgLoad}
                                            src={imageUrl(imageSrc)}
                                            alt={altSrc}
                                        />
                                    </TransformComponent>
                                </TransformWrapper>
                            </Row>
                        )}
                    </Zoom>
                </DialogContent>
            </BootstrapDialog>

        </>
    )

}

export default ImageZoom;